module.exports = __webpack_public_path__ + "facc6663ee655c3794ea23b3b5b52aca.pdf";